/**
 * @description 鉴权指令
 * 当传入的权限当前用户没有时，会移除该组件
 * 用例：<Tag v-auth="['admin']">text</Tag>
 * */
import store from '@/store';
import { includeArray } from '@/libs/system/index';

export default {
    inserted (el, binding, vnode) {
        const { value } = binding;
        const user = store.state.admin.user.info.user;
        if (user.is_admin) {
            return true
        }
        const access = store.state.admin.user.info.access;
        if (value && value instanceof Array && value.length && access && access.length) {
            const isPermission = includeArray(value, access);
            if (!isPermission) {
                el.parentNode && el.parentNode.removeChild(el);
            }
        } else {
            el.parentNode && el.parentNode.removeChild(el);
        }
    }
}
